import { FC, PropsWithChildren, useState } from 'react'
import { Button, CheckList, Popup } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less'

export const CheckListPopup: FC<{
  visible: boolean,
  setVisible(visible: boolean): any,
  options: any[],
  value?: any,
  onChange?(value: any): any,
  children: any,
  defaultValue?: any,
  // multiple: boolean,
  [key: string]: any,
}> = ({ visible, setVisible, options, value, onChange, children, defaultValue, ...rest }) => {
  const [myValue, setMyValue] = useState(() => defaultValue ? defaultValue : (value ?? []))
  const { t } = useTranslation();

  const onConfirm = () => {
    onChange(myValue)
    setVisible(false)
  }

  const onCancel = () => {
    setMyValue(() => value ?? [])
    setVisible(false)
  }


  return (
    <>
      <Popup bodyClassName={css.CheckListPopupBody} visible={visible}>
        <div className={css.BtnBar}>
          <Button className={css.Btn} fill='none' onClick={onCancel}>{t('common.cancel')}</Button>
          <Button className={css.Btn} color='primary' fill='none' onClick={onConfirm}>{t('common.confirm')}</Button>
        </div>
        <div className={css.checkListWrap}>
          <CheckList className={css.CheckList} {...rest} value={myValue} onChange={setMyValue}>
            {options.map(option => {
              const value = option.value ?? option;
              const label = option.label ?? option;
              return <CheckList.Item key={value} value={value}>{label}</CheckList.Item>
            })}
          </CheckList>
        </div>
      </Popup>
      {children(value)}
    </>
  )
}
